<template>
<div class="chapter">
<div class="inner_page">
<p class="p15"><img alt="img2.png" src="images/img2.png"/></p>
<p class="p17"><span class="t8"> </span></p>
<p class="p18"><span class="t9">A child is born, brought into the world as a lump of clay. Each hand that touches it, marks it, molds it, creates life. Some of those hands are talented, working the clay as it spins slowly on the wheel into beautiful shapes, flowing lines—art. Other less than talented hands slide awkwardly along the clay, trying over and over to add something good and whole to the piece. Fumbling fingers with good intentions leave their imperfections behind. Yet somehow, these blemishes, these mistakes, add to the uniqueness and yes, the beauty of the art. Then there are those who only wish to defile, destroy. They dig their fingers into the wet clay creating deep, ugly imprints, mangled globs of mud with no shape, no purpose, and no form. But the wheel keeps spinning; new hands begin to work the clay back into some semblance of order, talented hands, good hands. The clay can never be as it was originally, it’s irrevocably changed, but art and beauty can still be created.</span></p>
<p class="p19"><span class="t9">By the time I was thirteen, I had been touched, shaped, and molded by all three types of hands. I had been touched numerous times by the fingers whose sole purpose was to defile and destroy. In my young life, I had seen evil, been touched by evil, molded by evil, but there were always new hands.</span></p>
<p class="p19"><span class="t9">Good hands.</span></p>
<p class="p19"><span class="t9">Talented hands.</span></p>
<p class="p19"><span class="t9">Jamie’s hands.</span></p>
<p class="p19"> </p>
<p class="p19"><span class="t9">Tek Cain</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009.vue?563210b4